<label class="flex items-center gap-2 ml-2 text-sm font-medium text-gray-900 dark:text-gray-300 cursor-pointer truncate">
    <input [id]="id()" type="checkbox" class="cursor-pointer" [checked]="checked()" [value]="value()?.id" [disabled]="disabled()" (change)="onChange.emit($event)">
    <span [ngClass]="{'!font-bold': description()}">
        {{ text() || value()?.name }}
        @if (description()) {
            <span> - {{ description() }}</span>
        }
    </span>
</label>
